import { Modal } from '@models';
import { mixed, number, object, ObjectSchema } from 'yup';

import { ModalModelProperties } from '../ModalDetail';

export const modalModelSchema: ObjectSchema<ModalModelProperties> = object({
  segment: number().required('Este campo é obrigatório'),
  modalType: mixed<Modal.TypeEnum>()
    .oneOf(Object.values(Modal.TypeEnum))
    .required('Este campo é obrigatório'),
}).defined();
